module.exports = __webpack_public_path__ + "static/media/sketches-poster.38364dc0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Media/posterImgs/sketches-poster.jpg
// module id = 422
// module chunks = 0